let newFormModal = document.getElementById("newModal");
const closeButtont = document.getElementById("closePopupBtn");
const modalOpenBtn = document.getElementById("formModal");

modalOpenBtn.addEventListener("click", () => {
  newFormModal.showModal();
});
closeButtont.addEventListener("click", () => {
  newFormModal.close();
});

document
  .getElementById("submitBtn")
  .addEventListener("click", function (event) {
    event.preventDefault();
    const dataForm = document.getElementById("myForm");
    const name = document.getElementById("name").value.trim();
    const email = document.getElementById("email").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const address = document.getElementById("address").value.trim();
    const message = document.getElementById("message").value.trim();
    const productId = dataForm.getAttribute("data-product-id");
    if (!name || !email || !phone || !address || !message) {
      alert("Please fill in all required fields.");
      return;
    }

    submitBtn.disabled = true;
    const originalText = submitBtn.textContent;
    submitBtn.textContent = "Submitting...";
    submitBtn.classList.add('btn-disabled');
    
    const url =
      "https://script.google.com/macros/s/AKfycbz_1qfgS6HR1lY2T_nQsJ8uOop9SCohelgkxyOcf0H-PyEEeo5lLmpiiP-ZccPwqBBFEw/exec";

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("address", address);
    formData.append("message", message);

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.result === "success") {
          let checkOutcUrl = `/cart/add?id=${productId}&quantity=1&return_to=/checkout`;
          window.location.href = checkOutcUrl;
        } else {
          throw new Error(data.error.message || "Unknown error from server");
        }
      })
      .catch((error) => {
        alert(`Submission failed: ${error.message}`);
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
  });
